<template>
  <v-snackbar color="red" top :timeout="0" v-model="show">
    {{message}}
    
    <v-btn text @click.native="show = false">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    data() {
      return {
        message: '',
        color: '',
        show: false
      };
    },
    created() {
      this.$store.watch(state => state.snack, () => {
        const message = this.$store.state.snack;
        
        if(message) {
          this.show = true;
          this.message = message;

          this.$store.commit('setSnack', null);
        }
      });
    }
  };
</script>